module.exports = __webpack_public_path__ + "static/media/skn.b7bae276.svg";